<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Importowanie zlecenia spedycyjnego
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="number"
                                label="Numer"
                                :error-messages="numberErrors"
                                outlined
                                dense
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="onSave"
                >
                    Importuj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'

import { required } from 'vuelidate/lib/validators'

export default {
    name: 'AddShipmentsOrderDialog',
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            number: null,
            actionLoading: false
        }
    },
    validations() {
        return {
            number: {
                required
            },
        }
    },
    computed: {
        numberErrors() {
            const errors = []

            if (!this.$v.number.$dirty) return errors
            !this.$v.number.required && errors.push('Numer zlecenia jest wymagany.')

            return errors
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            const payload = {
                number: this.number
            }

            this.actionLoading = true

            this.$store.dispatch('shipments/shipmentsOrders/createShipmentsOrder', payload )
                .then(response => {
                    this.$router.push({
                        name: 'shipmentsShipmentsOrdersShipmentsOrder',
                        params: { shippingOrderId: response.data.id }
                    })
                        .catch(error => {
                            errorHandler(error)
                        })
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                    this.onClose()
                })
        },
        onClose() {
            setTimeout(() => {
                this.number = null
            }, 500)
            this.$v.$reset()

            this.$emit('on-close')
        }
    }
}
</script>
